import { collection, getDocs } from "@angular/fire/firestore";
import { DocumentData, QuerySnapshot, getFirestore } from "@firebase/firestore";
import { Observable, combineLatest, from, map, switchMap } from "rxjs";


export type PaymentTypes = "payment" | "subscription" | "monthly"

export const stripeProductCollectionAccumulator = (source$: Observable<QuerySnapshot<DocumentData, DocumentData>>) =>
  source$.pipe(
    switchMap(snapshot => {
      const productDocs = snapshot.docs.map(doc => {
        const prices$ = from(getDocs(collection(getFirestore(), `${doc.ref.path}/prices`)))
        .pipe(
          map(prices => prices.docs.filter(x => x.data()['active'])),
          map(priceSnapshot => priceSnapshot.map(priceDoc => ({
            id: priceDoc.id,
            ...priceDoc.data()
          })))
        );

        return prices$.pipe(
          map(prices => ({
            ...doc.data(),
            prices
          }))
        );
      });
      return combineLatest(productDocs);
    })
  )
